import React from 'react';
import MainHeader from './MainHeader';

export default function SneakPeak() {
  return <>
    <MainHeader />
  </>;
}
